<template>
  <div class="table-responsive">
    <base-crud
      crudName="Histórico de Consultas"
      newText
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="false"
      :enableEdit="false"
      :enableDelete="false"
      :enableView="false"
      :dataForm="dataForm"
      :extra="extra"
      @editing="editing"
      @cancel="cancel"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "requestsHistoryTable",
      // pages: [],
      // url: '',
      columns: [
        "id",
        "user_id",
        "created_at",
        "retreat_date",
        "devolution_date",
        "branch_id",
        "vehicle_type_id",
        "qtd_vehicles_available",
        "origin_request",
      ],
      tableData: [
        "id",
        "user_id",
        "created_at",
        "retreat_date",
        "devolution_date",
        "branch_id",
        "vehicle_type_id",
        "qtd_vehicles_available",
        "origin_request",
      ],
      options: {
        sortable: [
          "id",
          "user_id",
          "created_at",
          "retreat_date",
          "devolution_date",
          "branch_id",
          "vehicle_type_id",
          "qtd_vehicles_available",
          "origin_request",
        ],
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "id",
          "user_id",
          "retreat_date",
          "created_at",
          "devolution_date",
          "qtd_vehicles_available",
          "vehicle_type_id",
          "branch_id",
          "origin_request",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          user_id: "Nome do Usuário",
          created_at: "Data da Consulta",
          retreat_date: "Data de Retirada",
          devolution_date: "Data de Devolução",
          branch_id: "Filial",
          vehicle_type_id: "Tipo Veículo",
          qtd_vehicles_available: "Qtd Veículos Disponíveis",
          origin_request: "Origem da Consulta",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          reserve_status: [
            {
              id: 1,
              text: "Pré-reserva",
            },
            {
              id: 2,
              text: "Reservado",
            },
            {
              id: 3,
              text: "Cancelado",
            },
            {
              id: 4,
              text: "Retirado",
            },
            {
              id: 5,
              text: "Devolvido",
            },
          ],
        },
        templates: {
          user_id: function (h, row, index) {
            return row.user ? row.user.name : "Sem Nome";
          },
          branch_id: function (h, row, index) {
            return row.branch ? row.branch.description : "Sem Nome";
          },
          vehicle_type_id: function (h, row, index) {
            return row.vehicle_types
              ? row.vehicle_types.description
              : "Sem Nome";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [
            "user",
            "branch",
            "reserve_statuses",
            "vehicle_types",
          ];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      extra: [],
      endPoint: "requests_history/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        user_id: "user[name]",
        created_at: "created_at",
        retreat_date: "retreat_date",
        devolution_date: "vehicles[description]",
        branch_id: "branch_id[title]",
        vehicle_type_id: "vehicle_type_id",
        qtd_vehicles_available: "qtd_vehicles_available",
        origin_request: "origin_request",
      };

      let filters = "orderByDesc=id&";

      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
  mounted: function () {},
  computed: {},
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/RequestsHistory/Crud.vue